import { toLower } from "lodash";
import React from "react";
import { Form } from "react-bootstrap";

import { FormControl } from "../../";

const FieldNotSpecialChar = ({ field, form, onChange, ...rest }) => {
  let autoCompleteAttr = {
    autoComplete: "off",
  };
  if (["name", "firstName", "lastName", "middleName"].includes(field.name)) {
    autoCompleteAttr = {
      autoComplete: "new-name",
    };
  }
  if (rest.type === "password") {
    autoCompleteAttr = {
      autoComplete: "new-password",
    };
  }
  if (field.name === "email") {
    autoCompleteAttr = {
      autoComplete: "new-email",
    };
  }

  if (
    toLower(field.name).indexOf("postal") !== -1 ||
    toLower(field.name).indexOf("zip") !== -1
  ) {
    autoCompleteAttr = {
      autoComplete: "new-zip",
    };
  }
  return (
    <FormControl {...field} {...form} {...rest}>
      <Form.Control
        onKeyPress={(e) => {
          var regex = new RegExp("^[a-zA-Z0-9]+$");
          var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
          if (!regex.test(key)) {
            e.preventDefault();
            return false;
          }
        }}
        {...field}
        {...rest}
        {...autoCompleteAttr}
      />
    </FormControl>
  );
};

export default FieldNotSpecialChar;
